<template>
  <div class="otherInfopage flexCloumnSingleCenter">
    <div class="form">
      <div class="cell-group">
        <div class="flexCloumn" style="width: 100%;">
          <div class="item-title flexStart item-title-required">中考成绩证明</div>
          <div class="item-input1 flexCenter">
            <el-upload v-if="!disabled" :readonly="disabled" class="avatar-uploader" action=""
                       :http-request="uploadOss"
                       :on-success="uploadCover1" :show-file-list="false" name="image">
              <div class="avatar flexCenter">
                <img v-if="editForm.scorePhoto != ''" :src="editForm.scorePhoto" style="width: 100%">
                <img v-else src="../../../../../public/images/gxyzz_img/bd_other01.png" style="width: 100%">
<!--                <i  class="el-icon-plus avatar-uploader-icon"></i>-->
              </div>
              <div slot="tip" class="el-upload__tip">中考成绩证明
              </div>

            </el-upload>

            <div v-if="disabled&&editForm.scorePhoto != ''" class="avatar-uploader">
              <div v-if="editForm.scorePhoto != ''" class="avatar flexCenter">
                <img v-if="editForm.scorePhoto != ''" :src="editForm.scorePhoto" style="width: 100%">
              </div>
              <div v-if="editForm.scorePhoto != ''" slot="tip" class="el-upload__tip">中考成绩证明</div>
            </div>
          </div>

        </div>
      </div>
      <div class="cell-group-title flexStart"></div>
      <div class="cell-group">
        <div class="flexCloumn" style="width: 100%;">
          <div class="item-title flexStart item-title-required">户口簿</div>
          <div class="item-input1 flexCenter">
            <el-upload v-if="!disabled" :readonly="disabled" class="avatar-uploader" action=""
                       :http-request="uploadOss"
                       :on-success="uploadCover2" :show-file-list="false" name="image">
              <div class="avatar flexCenter">
                <img v-if="editForm.householdPhoto != ''" :src="editForm.householdPhoto" style="width: 100%">
                <img v-else src="../../../../../public/images/gxyzz_img/bd_other02.png" style="width: 100%">
              </div>
              <div slot="tip" class="el-upload__tip">上传户口本照片
              </div>

            </el-upload>

            <div v-if="disabled&&editForm.householdPhoto != ''" class="avatar-uploader">
              <div v-if="editForm.householdPhoto != ''" class="avatar flexCenter">
                <img v-if="editForm.householdPhoto != ''" :src="editForm.householdPhoto" style="width: 100%">
              </div>
              <div v-if="editForm.householdPhoto != ''" slot="tip" class="el-upload__tip">户口本照片</div>
            </div>
          </div>

        </div>
      </div>

      <div class="cell-group-title flexStart"></div>
      <div class="cell-group">
        <div class="flexCloumn" style="width: 100%;">
          <div class="item-title flexStart item-title-required">市民卡</div>
          <div class="item-input1 flexCenter">
            <el-upload v-if="!disabled" :readonly="disabled" class="avatar-uploader" action=""
                       :http-request="uploadOss"
                       :on-success="uploadCover3" :show-file-list="false" name="image">
              <div class="avatar flexCenter">
                <img v-if="editForm.citizenPhoto != ''" :src="editForm.citizenPhoto" style="width: 100%">
                <img v-else src="../../../../../public/images/gxyzz_img/bd_other04.png" style="width: 100%">
              </div>
              <div slot="tip" class="el-upload__tip">上传市民卡照片
              </div>

            </el-upload>

            <div v-if="disabled&&editForm.citizenPhoto != ''" class="avatar-uploader">
              <div v-if="editForm.citizenPhoto != ''" class="avatar flexCenter">
                <img v-if="editForm.citizenPhoto != ''" :src="editForm.citizenPhoto" style="width: 100%">
              </div>
              <div v-if="editForm.citizenPhoto != ''" slot="tip" class="el-upload__tip">市民卡照片</div>
            </div>
          </div>

        </div>
      </div>

      <div class="cell-group-title flexStart"></div>
      <div class="cell-group">
        <div class="flexCloumn" style="width: 100%;">
          <div class="item-title flexStart item-title-required">身份证照片</div>
          <div class="item-input1 flexCenter">
            <el-upload v-if="!disabled" :readonly="disabled" class="avatar-uploader" action=""
                       :http-request="uploadOss"
                       :on-success="uploadCover4" :show-file-list="false" name="image">
              <div class="avatar flexCenter">
                <img v-if="editForm.idPhoto1 != ''" :src="editForm.idPhoto1" style="width: 100%">
                <img v-else src="../../../../../public/images/gxyzz_img/bd_other06.png" style="width: 100%">
              </div>
              <div slot="tip" class="el-upload__tip">上传身份证正面照片
              </div>

            </el-upload>

            <div v-if="disabled&&editForm.idPhoto1 != ''" class="avatar-uploader">
              <div v-if="editForm.idPhoto1 != ''" class="avatar flexCenter">
                <img v-if="editForm.idPhoto1 != ''" :src="editForm.idPhoto1" style="width: 100%">
              </div>
              <div v-if="editForm.idPhoto1 != ''" slot="tip" class="el-upload__tip">身份证正面照片</div>
            </div>
          </div>

          <div class="item-input1 flexCenter">
            <el-upload v-if="!disabled" :readonly="disabled" class="avatar-uploader" action=""
                       :http-request="uploadOss"
                       :on-success="uploadCover5" :show-file-list="false" name="image">
              <div class="avatar flexCenter">
                <img v-if="editForm.idPhoto2 != ''" :src="editForm.idPhoto2" style="width: 100%">
                <img v-else src="../../../../../public/images/gxyzz_img/bd_other05.png" style="width: 100%">
              </div>
              <div slot="tip" class="el-upload__tip">上传身份证反面照片
              </div>

            </el-upload>

            <div v-if="disabled&&editForm.idPhoto2 != ''" class="avatar-uploader">
              <div v-if="editForm.idPhoto2 != ''" class="avatar flexCenter">
                <img v-if="editForm.idPhoto2 != ''" :src="editForm.idPhoto2" style="width: 100%">
              </div>
              <div v-if="editForm.idPhoto2 != ''" slot="tip" class="el-upload__tip">身份证反面照片</div>
            </div>
          </div>

        </div>
      </div>

    </div>
    <div v-if="!disabled" class="submitBtn flexCenter" style="">
      <div class="btn btnChange" @click="onSubmitForm">提交</div>
    </div>
    <div v-if="disabled" class="submitBtn flexCenter" style="">
      <div class="btn" @click="onModify">点击修改</div>
    </div>
    <div style="width: 100%;height: 100px;"></div>
  </div>
</template>

<script>
import {
  Toast, Dialog
} from 'vant';
import wx from 'weixin-js-sdk'

export default {
  // props: {
  //   tableInfo: {
  //     type:Object,
  //     default:{}
  //   },
  //   stu_id:{
  //     type:Number,
  //     default:0
  //   },
  //   pmid: {
  //     type:Number,
  //     default:5
  //   },
  // },
  data() {
    return {
      editForm: {
        scorePhoto:'',
        householdPhoto:'',
        citizenPhoto:'',
        idPhoto1:'',
        idPhoto2:'',
      },
      openid: null,
      disabled: false,
      pmid:5,
      stu_id:0,
      tableInfo:{},
    }
  },
  mounted() {
    let _this = this
    $(".otherInfopage").height($(window).height())//设置页面高度固定，防止输入法弹出页面变形，注意内部元素不能使用vh
    if (this.$route.query) {

      this.stu_id = Number(this.$route.query.stu_id)
      this.pmid = Number(this.$route.query.pmid)
      _this.getList(1)
    }
  },
  methods: {
    getList(flag) {
      let _this = this
      return new Promise(resolve => {
        this.$http.post('/api/t_stu_check_in_table_list', {
          pmid: _this.pmid,
          stu_id: _this.stu_id
        }).then(res => {
          for (let item of res.data.data) {
            if (item.table_name.indexOf('其他信息') != -1) {
              document.title = item.table_name
              _this.tableInfo = item
              if(flag == 1){
                if (item.table_detail) {
                  let detail = JSON.parse(item.table_detail)
                  _this.editForm = Object.assign(detail)
                  _this.disabled = true
                } else {
                  _this.editForm.stuName = _this.tableInfo.stu_name
                  _this.editForm = {..._this.editForm}
                  _this.disabled = false
                }
              }
              console.log(_this.editForm)
              resolve()
              return;
            }
          }
          resolve()
        })
      })
    },
    uploadCover1(e) {
      this.editForm.scorePhoto = e.src
      $("#loading").hide()
    },
    uploadCover2(e) {
      this.editForm.householdPhoto = e.src
      $("#loading").hide()
    },
    uploadCover3(e) {
      this.editForm.citizenPhoto = e.src
      $("#loading").hide()
    },
    uploadCover4(e) {
      this.editForm.idPhoto1 = e.src
      $("#loading").hide()
    },
    uploadCover5(e) {
      this.editForm.idPhoto2 = e.src
      $("#loading").hide()
    },
    onSubmitForm() {
      let _this = this
      console.log(this.editForm)
      if (!this.editForm.scorePhoto) {
        Toast('请上传中考成绩证明照片！');
        return
      }
      if (!this.editForm.householdPhoto) {
        Toast('请上传户口本单页照片！');
        return
      }
      if (!this.editForm.citizenPhoto) {
        Toast('请上传市民卡照片！');
        return
      }
      if (!this.editForm.idPhoto1) {
        Toast('请上传身份证正面照片！');
        return
      }
      if (!this.editForm.idPhoto2) {
        Toast('请上传身份证反面照片！');
        return
      }
      _this.getList(0).then(result=>{
        console.log(_this.tableInfo)
        let params = {}
        params.table_detail = JSON.stringify(_this.editForm)
        params.table_name = _this.tableInfo.table_name
        params.table_code = _this.tableInfo.table_code
        params.stu_id = this.stu_id
        params.table_type_id = _this.tableInfo.type_id
        params.pmid = this.pmid
        if(_this.tableInfo.id){
          params.id = _this.tableInfo.id
        }
        console.log(params)
        this.requestForm(params)
      })
    },
    requestForm(params) {
      let _this = this
      this.$http.post("/api/t_stu_check_in_table_edit", params).then(function (res) {
        if (res.data.id||res.data.message=='') {
          Toast('保存成功！')
          localStorage.removeItem('tableInfo')
          localStorage.removeItem('editForm')
          setTimeout(function (){
            _this.editForm = {}
            wx.miniProgram.navigateBack({
              delta: 1
            })
          },500)
          _this.preExport()
        } else {
          Toast(res.data.msg)
          _this.disabled = false
        }
      })

    },

    preExport() {
      let _this = this
      this.$http.post("/api/stu_luqu_detail", {
        stu_id: _this.stu_id,
        pmid: _this.pmid
      }).then(res => {
        console.log(res.data)
        if (res.data.class_id) {
          let params = {
            class_id: _this.editForm.class_id,
            stu_ids: _this.stu_id,
            pmid: _this.pmid,
          }
          _this.$http.post("/api/exportWord1", params).then(function (res) {})
        }

      })


    },

    onModify() {
      let curTime = new Date().getTime()
      let time1 = new Date(this.tableInfo.cdate).getTime()
      let val = curTime - time1
      this.getDuration(val).then(result => {
            console.log(result.d,result.h)
            if (result.d > 0 || result.h > 3) {
              this.disabled = false
            } else {
              Dialog.alert({
                title: "距上次提交时间小于3小时，请不要频繁修改。",
                showCancelButton: false,
                confirmButtonText: "确定",
                cancelButtonText: "关闭",
                confirmButtonColor: '#1283FF',
              }).then(() => {
                this.disabled = true
              }).catch(() => {
                console.log("点击了取消按钮噢")
              })
            }
          }
      )
      console.log(new Date(), this.tableInfo.cdate, this.tableInfo)
    },
    getDuration(my_time) {
      return new Promise(resolve => {
        var days = my_time / 1000 / 60 / 60 / 24;
        var daysRound = Math.floor(days);
        var hours = my_time / 1000 / 60 / 60 - (24 * daysRound);
        var hoursRound = Math.floor(hours);
        var minutes = my_time / 1000 / 60 - (24 * 60 * daysRound) - (60 * hoursRound);
        var minutesRound = Math.floor(minutes);
        var seconds = my_time / 1000 - (24 * 60 * 60 * daysRound) - (60 * 60 * hoursRound) - (60 * minutesRound);
        console.log('转换时间:', daysRound + '天', hoursRound + '时', minutesRound + '分', seconds + '秒');
        var time = hoursRound + ':' + minutesRound + ':' + seconds
        let obj = {d:daysRound,h:hoursRound}
        resolve(obj)
        return time;
      })

    },
  },
}
</script>

<style lang="less" type="text/less">
.el-textarea__inner:focus {
  outline: 0;
  border-color: #1283FF !important;
}

.van-radio__icon {
  font-size: 16px;
}
.van-radio__icon--checked .van-icon {
  background-color: #1283FF;
  border-color: #1283FF;
}

.van-checkbox {
  margin-top: 10px;
}
.van-checkbox__icon {
  font-size: 16px;
}
.van-checkbox__icon--checked .van-icon {
  background-color: #1283FF;
  border-color: #1283FF;
}

.van-tag--primary {
  background-color: #1283FF;
}

.van-cell--required::before {
  color: #1283FF !important;
}

.otherInfopage {
  display: block;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  background-color: #f5f5f5;

  .form {
    flex: 1;
    width: 100%;
    box-sizing: border-box;

    div {
      font-size: 14px;
      color: #323232;
      box-sizing: border-box;
    }

    .cell-group-title {
      margin: 10px 0 5px 15px;
      font-size: 14px;
      color: #969799;
    }

    .cell-group {
      background-color: #fff;
    }



    .item-title {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      padding: 10px 16px;
    }
    .item-title-required{font-weight: 700;position: relative;}
    .item-title-required::before {
      position: absolute;
      left: 8px;
      color: #1283FF;
      font-size: 14px;
      content: '*';
    }
    .item-title-required::after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 0px;
      bottom: 0;
      left: 0px;
      border-bottom: 1px solid #ebedf0;
      -webkit-transform: scaleY(.5);
      transform: scaleY(.5);
    }
    .item-input {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      padding: 0 16px 10px 16px;
      font-size: 14px;
      color: #646566;
    }

    .item-input1 {
      width: 100%;
      padding: 30px 0;
    }

    //上传头像
    .avatar-uploader {
      display: inline-block;
    }

    .avatar-uploader .el-upload {
      //margin-top: 10px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 50vw;
      height: 32vw;
      line-height: 32vw;
      text-align: center;
    }

    .avatar {
      width: 50vw;
      height: 32vw;
      overflow: hidden;
    }
    .el-upload__tip{
      width: 50vw;
      text-align: center;
      color: #909399;
    }

  }

  .submitBtn {
    padding-top: 6vh;
    width: 100%;

    .btn {
      display: inline-block;
      padding: 1.4vh 0;
      width: 60%;
      text-align: center;
      background-color: #1283FF;
      color: #fff;
      font-size: 15px;
      border-radius: 6px;
    }
  }
}

</style>
